// API responses can contain empty strings or serialized null values.
export const checkinText = (...values) => {
  for (const value of values) {
    if (typeof value !== 'string' && typeof value !== 'number') continue
    const text = String(value).trim()
    const isEmptyQuotedValue = /^(?:['"‘’“”]\s*)+$/.test(text)
    if (text && !isEmptyQuotedValue && !/^(null|undefined|n\/a)$/i.test(text)) return text
  }
  return ''
}
